export default __webpack_public_path__ + "static/media/bon_entendeur.ad101e25.png";